<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑广告' : '新增广告'"
      :visible.sync="showAddOrEdit"
      width="900px"
      :before-close="cancelFun"
      class="ad-dialog"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" label-width="130px" class="ad-form">
          <el-form-item label="页面" prop="pageCode" :rules="rules">
            <el-select 
              v-model="formData.pageCode" 
              placeholder="请选择页面"
              clearable
              class="form-select"
            >
              <el-option v-for="item in pageList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="image" :rules="rules">
            <FileUpload
              :isMulti="false"
              :limit="1"
              :name.sync="formData.image"
              :url="formData.imageUrl"
            ></FileUpload>
          </el-form-item>
          <el-form-item label="权重" prop="weight" :rules="rules">
            <el-input-number
              v-model="formData.weight"
              placeholder="请输入权重"
              :precision="0" 
              :step="1" 
              :min="0"
              :controls="false"
              class="form-input-number"
            ></el-input-number>
            <span class="form-tip">数字越小越靠前</span>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              placeholder="请输入备注信息（选填）"
              type="textarea"
              :rows="4"
              class="form-textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelFun" size="small">取 消</el-button>
        <el-button type="primary" @click="submitFun" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from "@/components/file-upload/index.vue";

import { getOprtAdDetailAPI, addOprtAdAPI, editOprtAdAPI } from "./api";
export default {
  name: "AddOrEdit",
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      formData: {
        name: "",
        pageCode: "",
        image: "",
        imageUrl: "",
        weight: "",
        remark: "",
      },
      pageList: [{
        name:'首页',
        value:'home'
      },{
        name:'我的',
        value:'mine'
      }],
    };
  },

  mounted() {
    if (this.rowId) this.getChannelDetail();
  },

  methods: {
    submitFun() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          (this.rowId ? editOprtAdAPI : addOprtAdAPI)(this.formData).then(() => {
            this.$message.success(this.rowId ? "编辑成功" : "新增成功");
            this.$emit("closeDialog",true);
          });
        }
      });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
    async getChannelDetail() {
      this.formData = await getOprtAdDetailAPI(this.rowId);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
.ad-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.ad-form {
  .form-select {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-input-number {
    width: 100%;
    max-width: 400px;

    ::v-deep {
      .el-input-number__decrease,
      .el-input-number__increase {
        display: none;
      }

      .el-input {
        .el-input__inner {
          border-radius: 4px;
          transition: all 0.3s ease;
          text-align: left;

          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
          }

          &:hover {
            border-color: #c0c4cc;
          }
        }
      }
    }
  }

  .form-textarea {
    width: 100%;
    max-width: 500px;

    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      resize: vertical;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 文件上传组件样式
.wrapper ::v-deep {
  .file-upload {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease;

      &:hover {
        border-color: #409EFF;
        background: #f5f7fa;
      }
    }

    .el-upload-dragger {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      transition: all 0.3s ease;

      &:hover {
        border-color: #409EFF;
        background: #f5f7fa;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .ad-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-select,
  .form-input-number,
  .form-textarea {
    max-width: 100% !important;
  }
}
</style>
